BackgroundAnimsView = {};

// Background container
BackgroundAnimsView.backgroundContainer = null;
BackgroundAnimsView.backgroundSpine = null;

BackgroundAnimsView.inFreeSpins = false;

BackgroundAnimsView.create = function (json) {
  return new PIXI.Container();
};

BackgroundAnimsView.onGameConfig = function () {};

BackgroundAnimsView.getFilesRequired = function (json) {
  return [];
};

BackgroundAnimsView.initialise = function () {
  BackgroundAnimsView.backgroundContainer = resourceManager.get("spineBackground");

  BackgroundAnimsView.backgroundSpine = resourceManager.createObject(
    "spine",
    "backgroundSpine",
    BackgroundAnimsView.backgroundContainer,
    {
      name: "backgroundSpine",
      x: 0,
      y: 0,
      defaultAnimation: "Background_animation_landscape",
    }
  );

  Reflex.registerEventHandler("orientationChange", this.onOrientationChange);
  BackgroundAnimsView.onOrientationChange();
};

BackgroundAnimsView.switchToFreeSpins = (toFreespins) => {
  BackgroundAnimsView.inFreeSpins = toFreespins;
  BackgroundAnimsView.onOrientationChange();
};

// TODO: Stop tween during orientation change
BackgroundAnimsView.onOrientationChange = function () {
  switch (layoutController.getCurrentLayout()) {
    case "landscape_default":
    case "landscape_mobile": {
      const animName = BackgroundAnimsView.inFreeSpins
        ? "Background_animation_landscape_freegames"
        : "Background_animation_landscape";
      BackgroundAnimsView.backgroundSpine.play(animName, true);
      break;
    }
    case "portrait_default":
    case "portrait_mobile": {
      const animName = BackgroundAnimsView.inFreeSpins
        ? "Background_animation_portrait_freegames"
        : "Background_animation_portrait";
      BackgroundAnimsView.backgroundSpine.play(animName, true);
      break;
    }
  }
};

resourceManager.registerObjectType(
  "BackgroundAnimsView",
  BackgroundAnimsView.create,
  BackgroundAnimsView.initialise,
  BackgroundAnimsView.getFilesRequired
);
